/**
 * Enum loại chi đầu tư
 */
export default {
  /**
   * Chi đầu tư theo nguồn
   */
  InvestCapital: 1,
  /**
   * Chi đầu tư theo lĩnh vực
   */
  InvestField: 2,
};
